<template>
<div class="upload"  @click.stop="() => {}">
    <button :class="btnClassName" @click.stop.prevent="onClick">
        <slot>
            <img src="../../assets/beautify/upload.svg" >
            上传图片
        </slot>
    </button>
    <input
        ref="input"
        class="input"
        type="file"
        hidden
        :accept="accept"
        @change="handleInput"
    >
</div>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    accept: {
      type: String,
      default: 'image/jpg, image/jpeg, image/png'
    },
    btnClassName: {
      type: String,
      default: 'upload-btn'
    }
  },
  methods: {
    onClick() {
      this.$refs.input.click();
      this.$emit('click');
    },

    handleInput(e) {
      var files = e.target.files;

      if (!files || files.length === 0) {
        return;
      }

      this.$emit('upload', files);
    }

  }
};
</script>
<style>
.upload-btn {
  cursor: pointer;
  width: 112px;
  height: 40px;
  background: #2254F4;
  border: 1px solid #2254F4;
  box-sizing: border-box;
  border-radius: 2px;
  color: #FFFFFF;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
}
.upload-btn img {
  width: 14px;
  height: 14px;
}
.upload .upload-img-btn {
  width: 192px;
  height: 48px;
  line-height: 48px;
  cursor: pointer;
  background: #2254F4;
  border: 1px solid #2254F4;
  box-sizing: border-box;
  border-radius: 2px;
  color: #FFFFFF;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}
.upload .upload-img-btn:hover {
  opacity: 0.9;
}

</style>
